<div class="container-fluid card border-0 rounded pt-2">
    <div class="row">
        <div *ngIf="!userview" class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-4 pr-0">
            <h6 class="font-weight-light page-header pt-1 d-none d-md-block ">{{'projectoverview.header' | trans }}</h6>
            <p class="page-header-sub d-none d-md-block" >{{ 'projectoverview.description' | trans }}</p>
        </div>
        <div *ngIf="userview" class="d-none d-md-block col-6 col-xl-3 col-lg-3 col-md-3 col-sm-4 pr-0">
            <h6 class="font-weight-light page-header pt-1">{{'projectoverview.secondheader' | trans }}</h6>
            <p class="page-header-sub">{{'projectoverview.secondsubheader' | trans }}</p>
        </div>

        <div class="col-auto"></div>
        <div *ngIf="!userview" class="col d-none d-lg-block d-xl-block">
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="pl-1 pr-1 bg-save rounded opacity cursor-pointer ml-1" *ngIf="ontrack" (click)="ontracktoggle()"
                            matTooltip="{{'projectoverview.removefilter' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                                <h6 class="mb-0 f-35 lh-50 align-middle center text-light display-inline pl-1 pr-1">{{projOntrack}}</h6>
                                <span class="material-icons text-light lh-50 align-middle display-inline ">
                                    recommend
                                </span>
                        </div>
                        <div class="pl-1 pr-1 cursor-pointer opacity display-inline" matTooltip="{{'projectoverview.filterontrack' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="!ontrack" (click)="ontracktoggle()" >
                        <h6 class="display-inline align-middle ml-1 c-save center f-35 lh-50 center pl-1 pr-1">{{projOntrack}}</h6>
                        <span class="material-icons c-save align-middle lh-50 display-inline pb-1">
                            recommend
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="cursor-pointer pl-1 pr-1 bg-almost rounded opacity ml-1" matTooltip="{{'projectoverview.removefilter' | trans }}" matTooltipPosition="above" 
                        matTooltipShowDelay="500" *ngIf="almost" (click)="almosttoggle()" >
                            <h6 class="mb-0 f-35 lh-50 align-middle center text-light display-inline pl-1 pr-1">{{projAlmost}}</h6>
                            <span class="material-icons text-light align-middle lh-50 display-inline">
                                error
                                </span>
                        </div>
                        <div matTooltip="{{'projectoverview.filteralmostontrack' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="!almost" (click)="almosttoggle()" class="cursor-pointer">
                            <h6 class="display-inline align-middle ml-1 c-almost f-35 lh-50 center pl-2 pr-2">{{projAlmost}}</h6>
                        <span class="material-icons c-almost align-middle lh-50 pb-1 display-inline">
                            error
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="cursor-pointer pl-1 pr-1 bg-close rounded opacity ml-1 bg-close" matTooltip="{{'projectoverview.removefilter' | trans }}" matTooltipPosition="above" 
                            matTooltipShowDelay="500" *ngIf="notontrack" (click)="notontracktoggle()" >
                            <h6 class="mb-0 f-35 lh-50 align-middle center text-light display-inline pl-1 pr-1">{{projNotontrack}}</h6>
                            <span class="material-icons text-light align-middle display-inline">
                                whatshot
                                </span>
                        </div>
                        <div class="cursor-pointer display-inline" matTooltip="{{'projectoverview.filterbynotontrack' | trans }}" matTooltipPosition="above"
                             matTooltipShowDelay="500" *ngIf="!notontrack" (click)="notontracktoggle()" >
                            <h6 class="display-inline align-middle ml-1 c-close f-35 lh-50 center pl-2 pr-2">{{projNotontrack}}</h6>
                            <span class="material-icons c-close align-middle lh-50 pb-1 center display-inline">
                                whatshot
                                </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="userview" class="col filter-box-control">
            <div class="row">
                <div class="col d-none d-sm-none d-md-none d-lg-block">
                    <div matTooltip="{{'projectoverview.numberoftask30' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"  class="pl-1 pb-2 cursor-pointer mb-1">
                        <h6 class="text-dark mb-0 center lh-50 ml-1 align-middle display-inline f-35">{{tasksDone.length}}</h6>
                        <span class="material-icons lh-50 align-middle pl-1 display-inline">
                            speed
                            </span>
                        <h6 class="ml-1 display-inline align-middle lh-58 mb-0">{{'projectoverview.donetaskttitle' | trans }}</h6>
                        </div>
                </div>
                <div class="col d-none d-sm-none d-md-block">
                    <div class="row">
                        <div class="pl-1 pr-1 bg-save rounded opacity cursor-pointer ml-1" *ngIf="ontrack" (click)="ontracktoggle()"
                            matTooltip="{{'projectoverview.removefilter' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                                <h6 class="mb-0 f-35 lh-50 align-middle center text-light display-inline pl-1 pr-1">{{tasksUpcoming.length}}</h6>
                                <span class="material-icons text-light lh-50 align-middle display-inline ">
                                    recommend
                                </span>
                        </div>
                        <div class="pl-1 pr-1 cursor-pointer opacity display-inline" matTooltip="{{'projectoverview.filterontrack' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="!ontrack" (click)="ontracktoggle()" >
                        <h6 class="display-inline align-middle ml-1 c-save center f-35 lh-50 center pl-1 pr-1">{{tasksUpcoming.length}}</h6>
                        <span class="material-icons c-save align-middle lh-50 display-inline pb-1">
                            recommend
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col d-none d-sm-none d-md-block">
                    <div class="row">
                        <div class="cursor-pointer pl-1 pr-1 bg-almost rounded opacity ml-1" matTooltip="{{'projectoverview.removefilter' | trans }}" matTooltipPosition="above" 
                        matTooltipShowDelay="500" *ngIf="almost" (click)="almosttoggle()" >
                            <h6 class="mb-0 f-35 lh-50 align-middle center text-light display-inline pl-1 pr-1">{{tasksDue.length}}</h6>
                            <span class="material-icons text-light align-middle lh-50 display-inline">
                                error
                                </span>
                                
                        </div>
                        <div matTooltip="{{'projectoverview.filteralmostontrack' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="!almost" (click)="almosttoggle()" class="cursor-pointer">
                            <h6 class="display-inline align-middle ml-1 c-almost f-35 lh-50 center pl-2 pr-2">{{tasksDue.length}}</h6>
                        <span class="material-icons c-almost align-middle lh-50 pb-1 display-inline">
                            error
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col d-none d-sm-none d-md-block">
                    <div class="row">
                        <div class="cursor-pointer pl-1 pr-1 bg-close rounded opacity ml-1 bg-close" matTooltip="{{'projectoverview.removefilter' | trans }}" matTooltipPosition="above" 
                            matTooltipShowDelay="500" *ngIf="notontrack" (click)="notontracktoggle()" >
                            <h6 class="mb-0 f-35 lh-50 align-middle center text-light display-inline pl-1 pr-1">{{tasksOverdue.length}}</h6>
                            <span class="material-icons text-light align-middle display-inline">
                                whatshot
                                </span>
                        </div>
                        <div class="cursor-pointer display-inline" matTooltip="{{'projectoverview.filterbynotontrack' | trans }}" matTooltipPosition="above"
                             matTooltipShowDelay="500" *ngIf="!notontrack" (click)="notontracktoggle()" >
                            <h6 class="display-inline align-middle ml-1 c-close f-35 lh-50 center pl-2 pr-2">{{tasksOverdue.length}}</h6>
                            <span class="material-icons c-close align-middle lh-50 pb-1 center display-inline">
                                whatshot
                                </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2 d-none d-sm-block">
            <app-projectwizard></app-projectwizard>
        </div>
        <div class="col- d-none d-sm-block">
            <!-- <button matTooltip="Create project" matTooltipPosition="above" matTooltipShowDelay="500" class="border-0 bg-transparent" data-toggle="modal" data-target="#projectwizard">
                <span class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-2 w-35 h-35">
                    add
                </span>
            </button>  -->
            <!-- Button trigger modal -->
  <!-- Modal -->
<!-- DASHBOARD AND STAT LINK
            <button matTooltip="View dashboard" matTooltipPosition="above" matTooltipShowDelay="500" class="border-0 bg-transparent" >
                <span class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-2 w-35 h-35">
                    dashboard
                </span>
            </button>  -->
<ng-container *ngIf="!this.showfilter">
    <button matTooltip="{{'projectoverview.viewallfiles' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" data-toggle="modal" data-target="#filelistModal" class="border-0 bg-transparent" (click)="filelistToggle()">
        <span class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-2 w-35 h-35">
            cloud_circle
        </span>
    </button> 
    <!--- USERVIEW DISABLED
    <button matTooltip="{{'projectoverview.toggleuserview' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="!userview" class="border-0 bg-transparent" (click)="userviewToggle()">
        <span  class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-2 w-35 h-35">
            account_circle
        </span>
    </button>
    <button matTooltip="{{'projectoverview.toggleuserview' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="userview" class="border-0 bg-transparent" (click)="userviewToggle()">
        <span class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-2 w-35 h-35">
            work
        </span>
    </button>--->
</ng-container>
       

       </div>
       <div *ngIf="!userview" class="col- cursor-pointer pt-1 pl-1 d-none d-sm-block"  
           matTooltip="{{'projectoverview.togglefreetext' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" (click)="showfilterToggle()">
               <span [ngClass]="{'bg-lightergrey': filterApplied }" class="material-icons mt-1 portal-icon btn rounded-circle center transistion align-middle p-0 w-35 h-35 lh-35">
                   filter_alt
               </span>
       </div>  
        </div> 

        <!----MOBILE OPTIONS--->
        <div class="d-flex flex-row d-block d-sm-none">
            <div *ngIf="!userview" class="pr-0">
                <h6 class="font-weight-light page-header pt-1">{{'projectoverview.header' | trans }}</h6>
                <p class="page-header-sub" >{{ 'projectoverview.description' | trans }}</p>
            </div>
            <div *ngIf="userview" class=" pr-0">
                <h6 class="font-weight-light page-header pt-1">{{'projectoverview.secondheader' | trans }}</h6>
                <p class="page-header-sub">{{'projectoverview.secondsubheader' | trans }}</p>
            </div>
            <div class="mt-2">
                <app-projectwizard></app-projectwizard>
            </div>
        <div class="">
            <ng-container *ngIf="!this.showfilter">
                <button matTooltip="{{'projectoverview.viewallfiles' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" data-toggle="modal" data-target="#filelistModal" class="border-0 bg-transparent" (click)="filelistToggle()">
                    <span class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-2 w-35 h-35">
                        cloud_circle
                    </span>
                </button> 
                <!--- USERVIEW DISABLED -->
                <button matTooltip="{{'projectoverview.toggleuserview' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="!userview" class="border-0 bg-transparent" (click)="userviewToggle()">
                    <span  class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-2 w-35 h-35">
                        account_circle
                    </span>
                </button>
                <button matTooltip="{{'projectoverview.toggleuserview' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="userview" class="border-0 bg-transparent" (click)="userviewToggle()">
                    <span class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-2 w-35 h-35">
                        work
                    </span>
                </button>
            </ng-container>
        </div>
        <div *ngIf="!userview" class="cursor-pointer pt-1 pl-1"  
        matTooltip="{{'projectoverview.togglefreetext' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" (click)="showfilterToggle()">
            <span [ngClass]="{'bg-lightergrey': filterApplied }" class="material-icons mt-1 portal-icon btn rounded-circle center transistion align-middle p-0 w-35 h-35 lh-35">
                filter_alt
            </span>
    </div> 
        </div>
</div>


<!-- Modal filelist -->
<div class="modal fade" id="filelistModal" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{'projectoverview.Filemodalheader' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-filelist [list]="true" [modal]="true" [filetype]="'org'"></app-filelist>
      </div>
    </div>
  </div>
</div>
